import { safeHref } from '@up2d8/rich-text';

/**
 * Een adres van de server waar de browser naartoe mag navigeren, of null.
 *
 * Download-URL's en snelkoppelingen komen van de API, maar een snelkoppeling is ooit door een
 * beheerder ingetypt en een download-URL is een adres van de opslag. `location.href` met een
 * `javascript:`-adres voert code uit in deze pagina; daarom alleen http(s), mailto en tel - dezelfde
 * regel als voor een link in een bericht (`safeHref`).
 */
export function safeNavigationUrl(value: unknown): string | null {
  return safeHref(value);
}
